class Gifts {

    constructor(config) {
        this.config = config;
        this.modal = null;
        this.steps = null;
        this.chosenGiftId = null;
        this.giftPrice = 0;
        this.chosenWrappingId = null;
        this.wrappingPrice = 0;
        this.tokensGift = 0;
        this.totalPriceContainer = null;
        this.messageInput = null;
        this.submitButton = null;
        this.username = null;
        this.privateInput = null;
        this.giftPreview = null;
        this.wrappingPreview = null;
    }

    getNewGiftModal(username) {
        app.ajax.get('/services/user/gifts/new', {'username': username}, this._newGiftModalReady.bind(this));
    }

    _newGiftModalReady(response) {
        app.modal.open('', response.body, '', undefined, function () {
            this.modal = document.querySelector('#newGiftModal');
            this.steps = new Steps('#newGiftModal');
            jQuery('#newGiftModal .gift-option').on('click', function (e) {
                this.chooseGift(e.currentTarget);
            }.bind(this));

            jQuery('#newGiftModal .wrapping-option').on('click', function (e) {
                this.chooseWrapping(e.currentTarget);
            }.bind(this));

            this.totalPriceContainer = this.modal.querySelector('.gift-total-price .tokens-display span');
            this.messageInput = this.modal.querySelector('textarea[name="message"]');
            this.privateInput = this.modal.querySelector('input[name="private"]');
            this.username = this.modal.querySelector('input[name="username"]').value;
            this.giftPreview = this.modal.querySelector('#gift-preview');
            this.wrappingPreview = this.modal.querySelector('#wrapping-preview');
            this.submitButton = document.querySelector('.submitButton');
            this.submitButton.addEventListener('click', this.sendGift.bind(this));

        }.bind(this));
    }

    chooseGift(giftElement) {
        if (this.chosenGiftId !== null) {
            document.querySelector('.gift-option[data-id="' + this.chosenGiftId + '"]').classList.remove('selected');
        }
        giftElement.classList.add('selected');
        this.chosenGiftId = giftElement.dataset.id;
        this.giftPrice = parseInt(giftElement.dataset.price);
        this.giftPreview.style.backgroundImage = "url('" + giftElement.querySelector('.gift-image img').src + "')";
        this.updateCheckout();
        this.steps.nextStep();
    }

    chooseWrapping(wrappingElement) {
        if (this.chosenWrappingId !== null) {
            this.modal.querySelector('.wrapping-option[data-id="' + this.chosenWrappingId + '"]').classList.remove('selected');
        }
        wrappingElement.classList.add('selected');
        this.chosenWrappingId = wrappingElement.dataset.id;
        this.wrappingPrice = parseInt(wrappingElement.dataset.price);
        this.wrappingPreview.style.backgroundImage = "url('" + wrappingElement.querySelector('.wrapping-image img').src + "')";
        this.updateCheckout();
        this.steps.nextStep();
    }

    updateCheckout() {
        this.totalPriceContainer.innerHTML = (this.giftPrice + this.wrappingPrice + (parseInt(this.tokensGift) ? this.tokensGift : 0)).toLocaleString(app.config.locale);
        if (this.giftPrice > 0 && this.wrappingPrice > 0) {
            this.submitButton.disabled = false;
            this.submitButton.classList.add('btn-green');
        }
    }

    sendGift() {
        app.ajax.post('/services/user/gifts/new', {
            gift_id: this.chosenGiftId,
            wrapping_id: this.chosenWrappingId,
            message: this.messageInput.value,
            username: this.username,
            private: this.privateInput.checked
        }, function (response) {
            app.modal.close();
            app.alert.success(response.header, response.message);
            app.ajax.reload("#profile-gifts");
        }, function (response) {
            app.alert.error('', response.error);
        });
    }

    showGiftModal(giftId) {
        app.ajax.get('/services/user/gifts/show-modal/' + giftId, [], this._giftModalReady.bind(this));
    }

    _giftModalReady(response) {
        app.modal.open('', response.html, '', 'gift-modal', function () {
            let modal = document.querySelector('#showGiftModal');
            let button = modal.querySelector('.open-text');
            if (button !== null) {
                button.addEventListener('click', function () {
                    this._revealGift(modal);
                }.bind(this, modal));
            }
        }.bind(this));
    }

    _revealGift(giftModal) {
        app.ajax.get('/services/user/gifts/open/' + giftModal.dataset.id, [], function (response) {
            app.ajax.reload("#gift-" + giftModal.dataset.id);
            let wrapping = giftModal.querySelector('.gift-container-sealed');
            let gift = giftModal.querySelector('.gift-container-open');
            let message = giftModal.querySelector('.user-gift-message');
            if (wrapping) {
                wrapping.classList.add('hidden');
            }
            if (gift) {
                gift.classList.remove('hidden');
            }
            if (message) {
                message.classList.remove('hidden');
            }
        }.bind(giftModal));

    }

    deleteGift(giftId) {
        app.ajax.delete('/services/user/gifts/' + giftId, [], function () {
            document.querySelector('.userGift[data-id="' + giftId + '"]').outerHTML = "";
        }.bind(giftId));
    }

    togglePrivate(giftId) {
        app.ajax.post('/services/user/gifts/private/' + giftId, {}, () => {
            app.modal.close(() => {
                this.showGiftModal(giftId);
            });
        });
    }
}
